import { cn } from '../../utils/classNames';

const labelClasses = "block mb-2 text-content font-sans";

const wrapperClasses = "w-full";

const selectBaseClasses = `
  w-full h-10! px-3 py-1.5
  font-sans text-base text-content
  bg-white border border-border rounded-md
  cursor-pointer transition-colors
  focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary-ring
  disabled:opacity-60 disabled:cursor-not-allowed
`;

const errorClasses = "block mt-1 ml-1 text-sm text-danger";

function XSelect({
    value,
    label,
    className,
    onChange,
    options,
    emptyOption = true,
    error,
    ...props
}) {
    return (
        <>
            {label && <label className={labelClasses}>{label}</label>}
            <div className={wrapperClasses}>
                <select
                    value={value}
                    className={cn(selectBaseClasses, className)}
                    onChange={onChange}
                    {...props}
                >
                    {emptyOption && (
                        <option value="">
                            {typeof emptyOption === 'string' ? emptyOption : 'Select'}
                        </option>
                    )}
                    {options?.length > 0 &&
                        options.map((option, index) => (
                            <option key={index} value={option.value}>
                                {option.text}
                            </option>
                        ))}
                </select>
                {error && <span className={errorClasses}>{error}</span>}
            </div>
        </>
    )
}

export default XSelect
